module.exports = __webpack_public_path__ + "img/googlepay1.bb7bf8ff.png";